<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-brief
			class="bg-gradient-to-r from-blue-600 via-blue-500 to-purple-400 border border-blue-400"
			[svgIcon]="typeOptions | getIconFromOptions: this.recordData().type"
			[title]="'vehicles|title'"
			[value]="
				this.recordData().type
					| getTranslationKeyFromValue: typeOptions
					| transloco
			">
			<div class="flex flex-col sm:flex-row gap-4 w-full mb-4">
				<div class="brief-item">
					<app-summary-item
						forceWhiteText
						[title]="'vehicles|display-section|field-label|license-plate'"
						[value]="this.recordData().licensePlate" />
				</div>

				<div class="brief-item">
					<app-summary-item
						forceWhiteText
						[title]="'vehicles|record|make-model-section|title'"
						[value]="this.recordData().makeFull" />
				</div>
			</div>
			<div class="flex flex-col sm:flex-row gap-4 w-full">
				<div class="w-full bg-neutral-50 bg-opacity-10 rounded-3xl text-white">
					<app-summary-item
						forceWhiteText
						[title]="'vehicles|record|details-section|field-label|fuel-type'"
						[value]="
							this.recordData().fuelType
								| getTranslationKeyFromValue: vehicleFuelTypes
								| transloco
						" />
				</div>

				<div class="w-full bg-neutral-50 bg-opacity-10 rounded-3xl text-white">
					<app-summary-item
						forceWhiteText
						[title]="'vehicles|record|details-section|field-label|steering-position'"
						[value]="
							this.recordData().steeringPosition
								| getTranslationKeyFromValue: steeringPositions
								| transloco
						" />
				</div>
			</div>
		</app-summary-brief>
	</div>
	@if (!isNew) {
		<app-module-selector
			[nav]="nav()"
			[isNew]="isNew"
			[recordId]="recordData().id" />
	}

	@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
		<div class="flex flex-col sm:flex-row gap-4">
			<app-summary-box-item
				[title]="'vehicles|record|odometer-section|title'"
				[value]="
					recordData().odometerValue && recordData().odometerUnit
						? recordData().odometerValue + ' ' + recordData().odometerUnit
						: recordData().odometerValue || recordData().odometerUnit
				" />

			<app-summary-box-item
				[title]="'vehicles|record|details-section|field-label|doors'"
				[value]="recordData().doors" />

			<app-summary-box-item
				[title]="'vehicles|record|details-section|field-label|seats'"
				[value]="recordData().seats" />
		</div>
	}

	@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
		<app-vehicle-links-status
			[recordData]="recordData()"
			[statusTracking]="statusTracking()" />
	}

	<div>
		<p class="p-4 pb-2 text-lg font-medium">
			{{ 'vehicles|summary-section|category-location' | transloco }}
		</p>
		<div class="flex gap-4 flex-col md:flex-row">
			@if (recordData().vehicleCategoryId) {
				<app-vehicle-category-link-card [id]="recordData().vehicleCategoryId" />
			}

			@if (recordData().locationId) {
				<app-location-link-card [id]="recordData().locationId" />
			}
		</div>
	</div>
</app-section-wrapper-container>
